var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5267 12.4189H17.5803V8.47252C17.5803 8.30555 17.4437 8.16895 17.2767 8.16895H8.47313C8.30616 8.16895 8.16956 8.30555 8.16956 8.47252V17.2761C8.16956 17.4431 8.30616 17.5797 8.47313 17.5797H12.4196V21.5261C12.4196 21.6931 12.5562 21.8297 12.7231 21.8297H21.5267C21.6937 21.8297 21.8303 21.6931 21.8303 21.5261V12.7225C21.8303 12.5556 21.6937 12.4189 21.5267 12.4189ZM12.4196 12.7225V16.2895H9.45973V9.45912H16.2901V12.4189H12.7231C12.5562 12.4189 12.4196 12.5556 12.4196 12.7225ZM16.2901 13.7091V16.2895H13.7097V13.7091H16.2901ZM20.5401 20.5395H13.7097V17.5797H17.2767C17.4437 17.5797 17.5803 17.4431 17.5803 17.2761V13.7091H20.5401V20.5395Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.4be1c4b8d618a5bb57d3ed135efce65b.svg";
export { ForwardRef as ReactComponent };